import React, { InputHTMLAttributes, useRef, useCallback } from "react";

import { IconType } from "react-icons";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  containerStyle?: object;
  icon?: IconType | React.ComponentType | undefined | null;
  disabled?: boolean;
}
const Input: React.FC<InputProps> = ({
  name,
  containerStyle = {},
  icon: Icon,
  disabled = false,
  className = "",
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleMaxLength = useCallback(
    (object: React.ChangeEvent<HTMLInputElement>): void => {
      if (object.target.maxLength > 0) {
        if (object.target.value.length > object.target.maxLength) {
          object.target.value = object.target.value.substring(
            0,
            object.target.maxLength
          );
        }
      }
    },
    []
  );
  return (
    <div
      className="input-container tw-border tw-rounded-md tw-px-2 tw-py-1 tw-flex tw-items-center tw-w-full"
      style={containerStyle}
    >
      <>
        {Icon && (
          <div className="icon-container">
            {React.createElement(
              Icon as React.ComponentType<{ size?: number }>,
              { size: 16 }
            )}
          </div>
        )}

        <input
          className={`tw-focus:outline-none tw-focus:border-none tw-focus:ring-2 ${className}`}
          name={name}
          ref={inputRef}
          onInput={handleMaxLength}
          disabled={!!disabled}
          {...rest}
        />
      </>
    </div>
  );
};

export default Input;
